import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@ui/Button";
import { Card } from "@ui/Card";
import { URLS } from "@/constants/urls";
import { cn } from "@/utils/tailwind";

interface FullAnalysisCardProps {
  className?: string;
}

export const FullAnalysisCard: FC<FullAnalysisCardProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Card className={cn("border-primary gap-6 p-6 lg:gap-10 lg:p-10 lg:px-12", className)}>
      <div className="space-y-2">
        <h2 className="text-2xl leading-normal font-bold lg:text-[34px]">
          {t("fullAnalysisCardTitle")}
        </h2>
        <h3 className="text-primary text-2xl leading-normal font-bold lg:text-[34px]">
          {t("fullAnalysisCardSubtitle")}
        </h3>
      </div>
      <Button className="text-base font-bold uppercase sm:mx-auto sm:w-fit" asChild>
        <Link to={URLS.SUMMARY}>{t("orderFullAnalysisButton")}</Link>
      </Button>
    </Card>
  );
};
